const topbar = {
    docs: 'Documentação',
    help: 'Ajuda',
    /** UNTRANSLATED */
    subscription: 'Subscription',
};
export default Object.freeze(topbar);
